import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import uploadPhoto from "../../../../Image/upload 1.png";
import delivery_truck from "../../../../Image/admin/delivery-truck-1.png";
import "./AdminViewQuote.css";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));
const AdminViewQuote = () => {
  const classes = useStyles();
  return (
    <div className="adminTReq">
      <div className="admin_viewQuote">
        <div className="rede_transport">
          <div className="rede_transport_img">
            <img src={delivery_truck} alt="delivery truck" />
          </div>
          <div className="rede_transport_text">
            <h6>Rode Transport</h6>
          </div>
        </div>
        <div className="upload_img_main">
          <div className="upload_img">
            <input
              accept="image/*"
              className={classes.input}
              id="icon-button-photo"
              type="file"
            />
            <label htmlFor="icon-button-photo">
              <img src={uploadPhoto} alt="uploadPhoto" />
            </label>
          </div>
          <div className="admin_quote_upload_text">
            <h6>Please upload the quote here.</h6>
          </div>
        </div>
        <div className="admin_quote_upload_btn">
          <button className="common-btn admin_quote_upload_btn1">Back</button>
          <button className="common-btn">Submit</button>
        </div>
      </div>
    </div>
  );
};

export default AdminViewQuote;
